import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { interval, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Directive({
   selector: '[samwebAutoFitFontSize]',
})
export class AutoFitFontSizeDirective implements AfterViewInit, OnDestroy {
   private destroy$ = new Subject();

   constructor(private element: ElementRef) {}

   ngAfterViewInit(): void {
      interval(250)
         .pipe(
            tap(() => this.recalculateFontSize()),
            takeUntil(this.destroy$)
         )
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }

   private recalculateFontSize() {
      const targetElement = this.element.nativeElement;
      const referenceElement = targetElement.parentNode;
      const computedStyle = getComputedStyle(referenceElement);

      const elementHeight = parseFloat(computedStyle.height) - parseFloat(computedStyle.paddingTop) - parseFloat(computedStyle.paddingBottom);
      const elementWidth = parseFloat(computedStyle.width) - parseFloat(computedStyle.paddingLeft) - parseFloat(computedStyle.paddingRight);
      let newFontSize = Math.max(1, Math.min(elementHeight, elementWidth) * 0.8);
      targetElement.style.fontSize = newFontSize + 'px';

      const updateStyle = getComputedStyle(targetElement);
      let oldWidth = 0.0;
      let newWidth = parseFloat(updateStyle.width);
      while (newWidth > elementWidth && newWidth !== oldWidth) {
         oldWidth = newWidth;
         newFontSize = newFontSize * 0.9;
         targetElement.style.fontSize = newFontSize + 'px';
         newWidth = parseFloat(getComputedStyle(targetElement).width);
      }
   }
}
